import { useState } from 'react';

const faqs = [
  {
    question: '韩漫之家上的漫画都是免费的吗？',
    answer: '是的！韩漫之家上所有漫画均免费提供在线观看。我们致力于为广大韩漫爱好者提供优质的免费阅读体验，无需付费即可畅读海量韩漫作品。我们通过广告等方式维持平台运营，确保读者可以持续享受免费服务。',
  },
  {
    question: '什么是下拉式韩漫？如何使用？',
    answer: '下拉式韩漫是一种适配手机阅读的漫画形式，您只需上下滑动屏幕即可流畅阅读，无需翻页。这种阅读方式由韩国网络漫画（Webtoon）首创，提供了更加沉浸式的阅读体验。在韩漫之家，所有作品均支持下拉式阅读。',
  },
  {
    question: '韩漫之家的更新频率是怎样的？',
    answer: '我们每日更新最新章节内容，确保读者能够第一时间追更喜爱的作品。热门漫画通常每周更新1-2话，部分人气作品可能会更高频更新。您可以在每部漫画的详情页查看具体的更新计划。',
  },
  {
    question: '如何在手机上阅读韩漫？',
    answer: '韩漫之家完美适配移动端浏览。您只需使用手机浏览器访问我们的网站，即可享受优化的移动阅读体验。所有漫画均采用响应式设计，在不同屏幕尺寸下都能获得流畅的阅读效果。',
  },
  {
    question: '韩漫之家的漫画来源是什么？',
    answer: '韩漫之家收录的漫画内容均来自正版授权的韩国漫画平台和出版社合作渠道，我们严格遵守版权法规，致力于为读者提供合法、优质的韩漫阅读服务，同时保护创作者的合法权益。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm mt-3">
            关于韩漫之家的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 overflow-hidden transition-colors"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="font-heading text-sm font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}